import { defineRouting } from 'next-intl/routing';
import { supportedLocales, defaultLocale, TRANSLATIONS_ENABLED } from './locales';

const isProd = process.env.BUILD_TYPE === 'prod';

export const routing = defineRouting({
  locales: TRANSLATIONS_ENABLED ? [...supportedLocales] : [defaultLocale],
  defaultLocale,
  localePrefix: 'as-needed',
  localeDetection: isProd ? false : undefined,
});
